import { Layout } from "@/components/site/Layout";
import { useSEO } from "@/hooks/useSEO";
import { useContact } from "@/context/ContactContext";

const Doc = ({ title, children }) => (
  <Layout>
    <section className="bg-[#0A1128] py-16"><div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8"><h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">{title}</h1></div></section>
    <section className="py-14 bg-white"><div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose-slate space-y-5 text-slate-600 leading-relaxed">{children}</div></section>
  </Layout>
);

export function Privacy() {
  useSEO({ title: "Privacy Policy", description: "Privacy Policy for WAAN METAL PTE. LTD." });
  const c = useContact();
  return (
    <Doc title="Privacy Policy">
      <p>WAAN METAL PTE. LTD. (“we”, “us”) is committed to protecting the personal data you share with us in accordance with Singapore's Personal Data Protection Act (PDPA).</p>
      <h2 className="text-xl font-bold text-slate-900">Information we collect</h2>
      <p>We collect the information you submit through our enquiry and quotation forms, including your name, contact details, project information and any files you upload.</p>
      <h2 className="text-xl font-bold text-slate-900">How we use your information</h2>
      <p>Your information is used solely to respond to enquiries, prepare quotations, carry out requested works and communicate with you about your project. We do not sell your personal data.</p>
      <h2 className="text-xl font-bold text-slate-900">File uploads</h2>
      <p>Uploaded files are stored securely and accessed only by authorised personnel for the purpose of assessing your enquiry.</p>
      <h2 className="text-xl font-bold text-slate-900">Retention & access</h2>
      <p>We retain personal data only as long as necessary for the stated purposes. You may request access to or correction of your data by contacting us.</p>
      <h2 className="text-xl font-bold text-slate-900">Contact</h2>
      <p>For privacy matters, email <a href={`mailto:${c.email}`} className="text-[#B87333]">{c.email}</a> or write to {c.address}.</p>
    </Doc>
  );
}

export function Terms() {
  useSEO({ title: "Terms of Service", description: "Terms of Service for WAAN METAL PTE. LTD." });
  return (
    <Doc title="Terms of Service">
      <p>These terms govern your use of the WAAN METAL PTE. LTD. website.</p>
      <h2 className="text-xl font-bold text-slate-900">No binding quotation</h2>
      <p>Information on this website, including the price guide, is indicative only and does not constitute a binding offer or quotation. Formal quotations are issued in writing after a site assessment.</p>
      <h2 className="text-xl font-bold text-slate-900">Regulated works</h2>
      <p>Structural, electrical, fire-safety and other regulated works are subject to applicable HDB, building and other regulatory approvals and are carried out by qualified, licensed professionals.</p>
      <h2 className="text-xl font-bold text-slate-900">Content accuracy</h2>
      <p>We endeavour to keep information accurate and current but make no warranty as to completeness. Credentials and project references are displayed only where verified.</p>
      <h2 className="text-xl font-bold text-slate-900">Intellectual property</h2>
      <p>All content on this website is owned by or licensed to WAAN METAL PTE. LTD. and may not be reproduced without permission.</p>
    </Doc>
  );
}
